module.exports = __webpack_public_path__ + "static/media/doctor-speak.b47269b5.svg";